import React from 'react';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import { EditorState, RichUtils } from 'draft-js';

const inlineStyles = [
  { icon: <FormatBoldIcon />, style: 'BOLD' },
  { icon: <FormatItalicIcon />, style: 'ITALIC' },
  { icon: <FormatUnderlinedIcon />, style: 'UNDERLINE' }
];

const blockTypes = [
  { icon: <FormatListBulletedIcon />, type: 'unordered-list-item' },
  { icon: <FormatListNumberedIcon />, type: 'ordered-list-item' }
];

const Toolbar = ({ editorState, setEditorState }) => {
  const StyleButton = ({ icon, style, toggle, active }) => {
    const onToggle = (e) => {
      e.preventDefault();
      toggle(style);
    };

    let className = 'text-editor__style-button';
    if (active) {
      className += ' text-editor__toggled';
    }
    return (
      <span
        className={className}
        onMouseDown={onToggle}
      >
        {icon}
      </span>
    );
  };

  const InlineStyleControls = () => {

    const toggleInlineStyle = (inlineStyle) => {
      setEditorState(RichUtils.toggleInlineStyle(editorState, inlineStyle));
    };

    const currentStyle = editorState.getCurrentInlineStyle();

    return (
      inlineStyles.map((type) => (
        <StyleButton
          key={type.style}
          icon={type.icon}
          style={type.style}
          active={currentStyle.has(type.style)}
          toggle={toggleInlineStyle}
        />
      ))
    );
  };

  const BlockTypeControls = () => {

    const toggleBlockType = (blockType) => {
      setEditorState(RichUtils.toggleBlockType(editorState, blockType));
    };

    const currentStyle = RichUtils.getCurrentBlockType(editorState);

    return (
      blockTypes.map((block) => (
        <StyleButton
          key={block.type}
          icon={block.icon}
          style={block.type}
          toggle={toggleBlockType}
          active={!currentStyle.indexOf(block.type)}
        />
      ))
    );
  };

  function onUndoClick() {
    setEditorState(EditorState.undo(editorState));
  }

  function onRedoClick() {
    setEditorState(EditorState.redo(editorState));
  }

  return (
    <div className="text-editor__toolbox">

      <button aria-label="close" className="text-editor__style-button" onClick={onUndoClick}>
        <UndoIcon />
      </button>
      <button aria-label="close" className="text-editor__style-button" onClick={onRedoClick}>
        <RedoIcon />
      </button>

      <InlineStyleControls />

      <BlockTypeControls />

    </div>
  );
};

export default Toolbar;
